module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\r\n    <div id="patients-select">\r\n        <div id="patient">\r\n            <b>Patient: </b>\r\n            ';
 if (patient) { 
__p+='\r\n            <a href="/#person/'+
((__t=( patient.id ))==null?'':__t)+
'"> '+
((__t=( patient.name ))==null?'':__t)+
' </a>\r\n            <span class="clickable glyphicon glyphicon-remove" id="'+
((__t=( patient.id ))==null?'':__t)+
'" title="Remove"/>\r\n            ';
 } else { 
__p+='\r\n            Is not set\r\n            ';
 } 
__p+='\r\n        </div>\r\n\r\n        <div class="form-horizontal top-margined col-xs-4 col-md-4">\r\n            <div class="form-group" id="patient-select">\r\n            </div>\r\n            <div class="form-group">\r\n                <div class="right">\r\n                    <button type="button" class="btn btn-primary" id="save">'+
((__t=( buttonText))==null?'':__t)+
'</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/document-patient-form.html
// module id = 415
// module chunks = 0